import { HEADER_HEIGHT, Shared } from "./shared";

export class ScrollRevealLock {

	constructor(node) {
		this.init(node);
	}

	init(node) {
		const selector = node.getAttribute('scroll-reveal-lock') || '.scroll-reveal-lock__wrapper';
		const wrapper = node.querySelector(selector);
		if (!wrapper) {
			throw ('ScrollRevealLock.error missing wrapper');
		}
		const content = wrapper.firstElementChild;
		if (!content) {
			throw ('ScrollRevealLock.error missing content');
		}
		this.node = node;
		this.wrapper = wrapper;
		this.content = content;
		this.viewRect = { width: 0, height: 0, top: 0, right: 0, bottom: 0, left: 0 };
		this.onResize();
		this.addListeners();
		// console.log('ScrollRevealLock.init', node, wrapper, content);
	}

	update() {
		const node = this.node;
		const previousElementSibling = node.previousElementSibling;
		const previousElementIsScrollLock = previousElementSibling.getAttribute('scroll-reveal-lock') !== null;
		const wrapper = this.wrapper;
		const content = this.content;
		const viewRect = this.viewRect;
		const contentRect = this.contentRect;
		const duration = 2; // previousElementIsScrollLock ? 1.5 : 2;
		node.style.height = contentRect.height * duration + 'px';
		const nodeRect = node.getBoundingClientRect();
		const isPositionStickySupported = Shared.isPositionStickySupported();
		if (isPositionStickySupported) {
			wrapper.style.position = 'sticky';
			wrapper.style.top = viewRect.top + 'px';
			wrapper.style.bottom = 0 + 'px';
		}
		// console.log(nodeRect.top, viewRect.top);
		if (nodeRect.top <= viewRect.top && nodeRect.bottom > viewRect.top + contentRect.height) {
			if (!isPositionStickySupported) {
				wrapper.style.left = nodeRect.left + 'px';
				wrapper.style.width = nodeRect.width + 'px';
				wrapper.style.top = viewRect.top + 'px';
				wrapper.style.position = 'fixed';
			}
			node.classList.add('active');
		} else {
			if (!isPositionStickySupported) {
				wrapper.style.position = 'relative';
				wrapper.style.left = null;
				wrapper.style.width = null;
				if (nodeRect.bottom < viewRect.top + contentRect.height) {
					wrapper.style.top = nodeRect.height - contentRect.height + 'px';
				} else {
					wrapper.style.top = null;
				}
			}
			node.classList.remove('active');
		}
		/*
		if (nodeRect.top < viewRect.top + viewRect.height / 2 && nodeRect.bottom > viewRect.top + contentRect.height) {
			node.classList.add('active');
		} else {
			node.classList.remove('active');
		}
		*/
		// console.log('ScrollRevealLock.update', nodeRect, contentRect);
	}

	onScroll() {
		// console.log('ScrollRevealLock.onScroll');
		this.update();
	}

	onResize() {
		// console.log('ScrollRevealLock.onResize');
		const content = this.content;
		const contentRect = content.getBoundingClientRect();
		const viewRect = { width: window.innerWidth, height: window.innerHeight - HEADER_HEIGHT, top: HEADER_HEIGHT, right: window.innerWidth, bottom: window.innerHeight, left: 0 };
		const dy = viewRect.height > contentRect.height ? (viewRect.height - contentRect.height) / 2 : 0;
		viewRect.top += dy;
		viewRect.bottom -= dy;
		viewRect.height = viewRect.bottom - viewRect.top;
		this.viewRect = viewRect;
		this.contentRect = contentRect;
		this.update();
	}

	addListeners() {
		this.onScroll = this.onScroll.bind(this);
		this.onResize = this.onResize.bind(this);
		document.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onResize);
	}

	removeListeners() {
		document.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.onResize);
	}

	destroy() {
		this.removeListeners();
		// console.log('ScrollRevealLock.destroy');
	}

	static init() {
		this.items = Array.prototype.slice.call(document.querySelectorAll('[scroll-reveal-lock]')).map(x => new ScrollRevealLock(x));
	}

	static destroy() {
		if (this.items) {
			while (this.items.length) {
				this.items.pop().destroy();
			}
		}
	}

}
